import { render, staticRenderFns } from "./selectMusicTiktok.vue?vue&type=template&id=1871a9dc&"
import script from "./selectMusicTiktok.vue?vue&type=script&lang=js&"
export * from "./selectMusicTiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports